
function check_bundle(e) {
  let error = "";

  const selects = document.querySelectorAll('.product__bundle_container select');

  selects.forEach((select, index) => {
    if (!select.value || select.value === "-") {
      if (select.dataset.bundleLabel) {
        error += "<p>- Vous avez oublié de sélectionner : " + select.dataset.bundleLabel + "</p>";
      } else {
        error += "<p>- Vous avez oublié de sélectionner le produit N°" + (index + 1) + "</p>";
      }
    }
  });

  if (error.length > 0) {
    document.getElementById("custom-error").innerHTML = error;
    document.getElementById("custom-error").style.display = 'block';
    e.preventDefault();
    e.stopPropagation();
    return false;
  } else {
    document.getElementById("custom-error").style.display = 'none';
    document.getElementById("custom-error").innerHTML = "";
    return true;
  }
}